import request from '@/utils/request'

/**
 * 获取小程序登录码
 */
export const getQRcode = (data) => {
  return request({
    url: '/custuser/client/login/getQRCode',
    data,
    method: 'post',
  })
}

/**
 * 获取小程序登录状态
 */
export const getQRStatus = (params) => {
  return request({
    url: `/custuser/client/login/getLoginQRStatus/${params.uuid.slice(-16)}`,
    params,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/applet/index.js